import * as React from "react";
import { TextBox } from "../../forms/informedv2/TextBox";
import { Required } from "../../forms/validation/Required";
import { useFormApi } from "informed";

export interface ReportsAdministationFormProps {
    handleSubmit: (form) => void;
    isConnected?: boolean;
    defaultServerURL: string;
    defaultUsername: string;
}

export const ReportsAdministrationForm = (props: ReportsAdministationFormProps) => {
    const [submitting, setSubmitting] = React.useState(false);
    const formApi = useFormApi();

    const onSubmit = () => {
        setSubmitting(true);
        formApi.validate();

        const state = formApi.getState();

        if (state.invalid) {
            setSubmitting(false);
            return;
        }

        props.handleSubmit(state.values);
        setSubmitting(false);
    }

    return (
        <>
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="ServerURL" className="pull-right">Report Server Location</label>
                    </div>
                    <div className="col-sm-8">
                        <div>Enter the URL of the report server to connect to</div>
                        <TextBox initialValue={props.isConnected ? props.defaultServerURL : null} defaultValue={props.isConnected ? props.defaultServerURL : null} field="ServerURL" id="ServerURL" validate={Required} className="form-control" />
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="Username" className="pull-right">Username</label>
                    </div>
                    <div className="col-sm-8">
                        <div>Enter the generic user account that the Web Portal should use to connect to the Report Server</div>

                        {props.isConnected ? <TextBox initialValue={props.defaultUsername} defaultValue={props.defaultUsername} id="Username" field="Username" validate={Required} className="form-control" />
                            : <TextBox defaultValue={null} id="Username" field="Username" validate={Required} className="form-control" />
                            }
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-4">
                        <label htmlFor="Password" className="pull-right">Password</label>
                    </div>
                    <div className="col-sm-8">
                        <div>Enter the password of the generic user account that the Web Portal should use to connect to the Report Server</div>
                        <TextBox field="Password" id="Password" type="password" validate={Required} className="form-control" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <button className="btn btn-primary" type="submit" disabled={submitting} onClick={() => onSubmit()}>Connect</button>
                    </div>
                </div>
            </div>
        </>
    );
}
